<template>
  <div>
    <navbar
      :items="navbarItems"
      :fonticon="pageIcon"
      :navbartitle="pageTitle"
      :navbardescription="pageDescription"
    />
    <div class="row">
      <div class="col-12">
        <div class="widget">
          <div class="widget-content">
            <div class="row">
              <div class="col-12">
                <data-table
                  :data-source="sortedAbonnement"
                  :headers="headers"
                  table-class="table-striped table-hover"
                  @search="search"
                >
                  <template slot="actions">
                    <a
                      href="javascript:void(0)"
                      class="btn btn-sm btn-primary"
                      @click.prevent="onlyMyPack = true"
                    > Mes Packs</a>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-sm btn-success"
                      @click.prevent="onlyMyPack = false"
                    > Tout</a>
                  </template>
                </data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../../components/navbar.vue';
import DataTable from '../../components/dataTable/local'
import {mapGetters} from 'vuex'
import moment from 'moment'
import { BOOLEAN_TYPE, COMPONENT_TYPE, DATE_TYPE, NUMERIC_TYPE, TEXT_TYPE } from '../../components/dataTable/dataType';
const Actions = () => import('../../components/pack/abonnement/actions.vue')
const Modules = () =>  import('../../components/pack/abonnement/module.vue')
const Pack = ()  => import('../../components/pack/abonnement/pack.vue')
const Animal = () => import('../../components/sanitaire/animal.vue')
export default {
    components: {Navbar, DataTable},
    data(){
        return {
            navbarItems: [
                {
                    libelle: 'Abonnement'
                }
            ],
            pageIcon: 'la-box',
            pageTitle: 'Les abonnements',
            pageDescription: 'Liste des abonnements',
            listMode: true,
            onlyMyPack: false,
            searchAbonnements: []
        }
    },
    watch:{
        abonnements: {
            deep: true,
            handler(){
                this.searchAbonnements = this.abonnements
            }
        }
    },
    mounted(){ this.searchAbonnements = this.abonnements},
    methods: {
      search(payload){
        const query = payload.search
              if(query === '') this.searchAbonnements = this.abonnements
              else{
                this.searchAbonnements = this.abonnements.filter(abonnement =>
                  this.$options.filters.deepSearch(abonnement, query)|| 
                  this.$options.filters.deepSearch(this.animaux.find(animal => animal.uid === abonnement.animal), query)||
                  this.$options.filters.deepSearch(this.packs.find(pack => pack.uid === abonnement.pack), query)
                )
              }
      }
    },
    computed: {
        ...mapGetters({
            abonnements: 'packs/abonnements',
            animaux: 'identification/animaux',
            packs: 'packs/packs',
            me: 'auth/me',
            is_super_admin: 'auth/is_super_admin',
        }),
        sortedAbonnement(){
            if(this.onlyMyPack){
                let myPack = [...this.packs].filter(item => item.agent === this.me.uid)
                return [...this.searchAbonnements].filter(abonnement => myPack.map(element => element.uid).includes(abonnement.pack))
                .sort((b,a) => moment(a.createdAt).format('X') - moment(b.createdAt).format('X'))
            }
            return [...this.searchAbonnements].sort((b,a) => moment(a.createdAt).format('X') - moment(b.createdAt).format('X'))
        },
        headers(){
            return [
                {label: 'ID', name: 'uid', type: TEXT_TYPE, visible: this.is_super_admin},
                {label: 'Animal', name: 'animal', type: COMPONENT_TYPE, component: Animal},
                {label: 'Pack', name: 'pack', type: COMPONENT_TYPE, component: Pack},
                {label: 'Module', name: 'modules', type: COMPONENT_TYPE, component: Modules},
                {label: 'Prix', name: 'amount', type: NUMERIC_TYPE, sortable: true},
                {label: 'Date abonnement', name: 'createdAt', type: DATE_TYPE, sortable: true},
                {label: 'Dernier renouvel.', name: 'lastRenew', type: DATE_TYPE, sortable: true},
                {label: 'Actif', name: 'actif', type: BOOLEAN_TYPE, sortable: true},
                {label: 'Action', name: 'action', type: COMPONENT_TYPE, component: Actions},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.widget{
    .widget-content{
        padding-top: 20px
    }
}

</style>